export const baseData = {
  title: "PRODUCT PRICING LEVEL"
}